import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class ZuordnungEnergieWaermequelle extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    energie_waermequelle_id: number | null = null;
    bemerkung: string | null = null;

    // view fields:
    energie_waermequelle_i18n_key: string | null = null;
    energie_waermequelle_code: number | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'ZuordnungEnergieWaermequelle';
    }
}

export async function createNewZuordnungEnergieWaermequelle(): Promise<ZuordnungEnergieWaermequelle> {
    const model = createModel(ZuordnungEnergieWaermequelle, {});

    await model.save();
    return model;
}

export class ZuordnungEnergieWaermequelleCollection extends BaseCollection<ZuordnungEnergieWaermequelle> {
    protected modelCls = ZuordnungEnergieWaermequelle;

    public getModelClassName(): string {
        return 'ZuordnungEnergieWaermequelle';
    }
}
